import { useEffect, useState } from "react";
import { ISubscription } from "../entity/subscriptions/ISubscription";
import { updateSubscriptionUseCase } from "../useCases/updateSubscriptionUseCase";
import { getSubscriptionsUseCase } from "../useCases/getSubscriptionsUseCase";
import { toastService } from "src/libraries/toast";
import { useUiContext } from "src/UIProvider";

export const useSubscriptionsTableItem = (item: ISubscription) => {
    const { t } = useUiContext();
    const [subscription, setSubscription] = useState(item);

    useEffect(() => {
        setSubscription(item);
    }, [item]);

    const onChange = (value: any, field: string) => {
        setSubscription(prev => ({ ...prev, [field]: value }));
    };

    const onChangeAppleId = (value: any) => {
        onChange(value, 'apple_product_id');
    }

    const onChangeGoogleId = (value: any) => {
        onChange(value, 'google_product_id');
    }

    const handleBlur = async () => {
        if (JSON.stringify(item) !== JSON.stringify(subscription)) {
            const res = await updateSubscriptionUseCase({
                id: item.id,
                apple_product_id: subscription.apple_product_id,
                google_product_id: subscription.google_product_id
            });
            if (!res?.isError) {
                toastService.onSuccess(t('subscriptions.priceChanged'));
                await getSubscriptionsUseCase();
            }
        }
    };

    return { onChangeAppleId, onChangeGoogleId, subscription, handleBlur }
};